import Manager from "../../src/manager";
import React from "react";
import Functions from "../../src/functions";

function Mapper(data, status, response, error, component) {
  let output = [];
  let property = {};
  if(data){
    property["data"] = data;
    sessionStorage.setItem('rli', data.rli);
  }
  output.push(property);
  return output;
}

function Properties(args) {
  let editable = args.editable ? true : false;
  return {
    header: {
      alias: "header",
      type: "module",
      configuration: {
        module: "header",
        view: "list",
      },
      editable,
    },
    data: {
      alias: "data",
      type: "text",
    },
    footer: {
      alias: "footer",
      type: "module",
      configuration: {
        module: "footer",
        view: "list",
      },
      editable,
    },
    main: {
      alias: "main",
      type: "module",
      configuration: {
        module: "cosmoteAvailableContracts",
        view: "list",
      },
      editable,
    },
  };
}

const CreditSubmit = {
  auth: "",
  views: {
    list: {
      apis: {
        view: {
          url: "/page/creditSubmitService",
          method: "POST",
          postData: function () {
            let UserType = Functions["custom"]["getUserType"]();
            if(UserType === "HYBRID_BUSINESS_COST_CONTROL"){
              return {
                rli: sessionStorage.getItem('rli'),
                id: sessionStorage.getItem("id"),
                pt: sessionStorage.getItem("pt"),
                prepaidService: {
                  listOfAvailableTypesOfPurchase: JSON.parse(sessionStorage.modalData).modal.listOfAvailableTypesOfPurchase
                }
              }
            } else {
              return {

                rli: sessionStorage.getItem('rli'),
                id: sessionStorage.getItem("id"),
                groupId: sessionStorage.getItem("groupId")
              }
            }
          },
          headers: {
            "Content-Type": "application/json"
          },
          mapper: Mapper,
        },
      },
      template: "creditSubmitService",
      templateConfiguration: {
        includeProperties: ["none"],
        excludeProperties: [],
        events: { onClick: function (e) {} },
      },
      properties: Properties({ editable: false }),
      primaryKey: "id",
    },
  },
};

export default CreditSubmit;
